(function() {
  // escape hatch
  if (!document.querySelector(".event-section-link"))
    return;

  // setup
  const sectionLinks = Array.from(
    document.querySelectorAll(".event-section-link")
  );

  // events
  sectionLinks.forEach((link) => {
    handleSectionLink(link);
  });

  // functions
  function handleSectionLink(link) {
    // get link destination
    const destination = link.dataset.sectionLink;
    link.addEventListener("click", (e) => {
      if (e.target.closest("a") || e.target.closest("button") || e.target.closest("form") || e.target.closest(".event-section-buttons")) {
        // do nothing if event target has any of the listed ancestors
        return;
      } else {
        // otherwise, redirect to the section link url
        window.location = destination;
      }
    });
  }
})();
